import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/landingFeatures/explorer.png";
import { Button } from "antd";
import {
  CheckCircleOutlined,
  FileAddOutlined,
  TeamOutlined,
  DashboardOutlined,
  DollarCircleOutlined,
  ArrowRightOutlined,
  MenuOutlined,
  CloseOutlined
} from "@ant-design/icons";

import "./nujobsEmployerPage.scss";
import { useState } from "react";
import FooterNuJobs from "../footerNuJobs";

export default function NuJobsEmployerPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const features = [
    {
      icon: <FileAddOutlined />,
      title: "Quick Job Posting",
      description:
        "Create and publish your job openings in minutes with a simple posting process.",
    },
    {
      icon: <TeamOutlined />,
      title: "Receive Applications",
      description:
        "Candidates can directly apply to your jobs through NuJobs.",
    },
    {
      icon: <DashboardOutlined />,
      title: "Applicant Dashboard",
      description:
        "View your job postings and candidate applications from one simple dashboard.",
    },
    {
      icon: <DollarCircleOutlined />,
      title: "Affordable Hiring",
      description:
        "Simple and transparent pricing designed for startups, SMEs and growing teams.",
    },
  ];

const pricingPlans = [
  {
    name: "NuJobs Launch",
    jobs: 50,
    price: "₹6,999",
    perJob: "₹140 / job",
    popular: true,
    buttonText: "Get Launch Offer- Free for 2 months",
  },
  {
    name: "Starter",
    jobs: 1,
    price: "-",
    perJob: "-",
    popular: false,
    buttonText: "Post 1 Job (Coming Soon)",
  },

  {
    name: "Growth",
    jobs: 5,
    price: "-",
    perJob: "-",
    popular: false,
    buttonText: "Buy 5 Jobs (Coming Soon)",
  },

  {
    name: "Business",
    jobs: 10,
    price: "-",
    perJob: "- ",
    popular: false,
    buttonText: "Buy 10 Jobs (Coming Soon)",
  },
];
  const handleSignin = () => {
    navigate("/nujobsotpprocess", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });
  };


  const handlePostJobs = () => {
    navigate("/otpprocess/nujobs", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });    
  };

 
  const handleSignup = () => {
     navigate("/signup/nujobs");   
  };

  return (
    <div className="nujobs-employer-page">
       <div className="jobListing-header"> 
          <div className="jobListing-header-logo">
              <img className="jobListing-logo-img"src={logo} />
          </div>
          <div className="header-menu">
            <ul className="header-menu">
              <li >
                <a href="/nujobs">Jobs</a>
              </li>
              <li>
                <a href="/nujobsemployerpage">For Employers</a>
              </li>      
              <li>
                <a href="/nujobscontact">Support</a>
              </li>                                                                   
            </ul>
          </div>
          <div
            className="jobListing-mobile-menu"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <CloseOutlined /> : <MenuOutlined />}
          </div>   
               
          <div className="header-sign">
            <Button className="job-button" onClick={() => handleSignup()}>
              Employers Sign Up
            </Button>                                     
          </div>          
       </div>
        {mobileMenuOpen && (
          <div className="jobListing-mobile-menu-dropdown">

            <a
              href="/nujobs"
              onClick={() => setMobileMenuOpen(false)}
            >
              Jobs
            </a>
            <a
              href="/nujobsemployerpage"
              onClick={() => setMobileMenuOpen(false)}
            >
              Employers
            </a>
            <a
              href="/nujobscontact"
              onClick={() => setMobileMenuOpen(false)}
            >
              Support
            </a>

          </div>
        )}
      {/* ======================================================
          HERO
      ====================================================== */}

      <section className="nujobs-employer-hero">
        <div className="nujobs-employer-container">
          <div className="nujobs-employer-hero-content">

            <div className="nujobs-employer-hero-text">
              <span className="nujobs-employer-badge">
                NuJobs for Employers
              </span>

              <h1>
                Hire Better.
                <br />
                Post Jobs.
                <br />
                <span>Get Applications.</span>
              </h1>

              <p>
                Reach candidates actively looking for opportunities.
                Post your jobs in minutes and receive applications directly
                through NuJobs.
              </p>

              <div className="nujobs-employer-hero-buttons">
                <Button
                  onClick={handlePostJobs}
                  className="nujobs-employer-primary-btn"
                >
                  Post a Job
                  <ArrowRightOutlined />
                </Button>

                <a
                  href="#pricing"
                  className="nujobs-employer-secondary-btn"
                >
                  View Pricing
                </a>
              </div>

              <div className="nujobs-employer-hero-points">
                <span>
                  <CheckCircleOutlined />
                  Simple Pricing
                </span>

                <span>
                  <CheckCircleOutlined />
                  Direct Applications
                </span>

                <span>
                  <CheckCircleOutlined />
                  No Long-Term Commitment
                </span>
              </div>
            </div>

            <div className="nujobs-employer-hero-card">
              <div className="nujobs-employer-job-preview">

                <div className="job-preview-header">
                  <span>Job Posting Preview</span>

                  <span className="job-preview-status">
                    LIVE
                  </span>
                </div>

                <h3>Senior Java Developer</h3>

                <p>
                  Bangalore • 5-8 Years
                </p>

                <div className="job-preview-skills">
                  <span>Java</span>
                  <span>Spring Boot</span>
                  <span>Microservices</span>
                </div>

                <div className="job-preview-divider" />

                <div className="job-preview-stat">
                  <div>
                    <strong>24</strong>
                    <span>Applications</span>
                  </div>

                  <div>
                    <strong>8</strong>
                    <span>New</span>
                  </div>

                  <div>
                    <strong>5</strong>
                    <span>Reviewed</span>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ======================================================
          FEATURES
      ====================================================== */}

      <section className="nujobs-employer-section">
        <div className="nujobs-employer-container">

          <div className="nujobs-employer-section-heading">
            <span>
              WHY NUJOBS?
            </span>

            <h2>
              Everything You Need to Start Hiring
            </h2>

            <p>
              A simple job posting platform designed to help employers
              connect with candidates without complicated recruitment tools.
            </p>
          </div>

          <div className="nujobs-employer-feature-grid">
            {features.map((feature, index) => (
              <div
                className="nujobs-employer-feature-card"
                key={index}
              >
                <div className="feature-icon">
                  {feature.icon}
                </div>

                <h3>
                  {feature.title}
                </h3>

                <p>
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* ======================================================
          HOW IT WORKS
      ====================================================== */}

      <section className="nujobs-employer-how-section">
        <div className="nujobs-employer-container">

          <div className="nujobs-employer-section-heading">
            <span>
              HOW IT WORKS
            </span>

            <h2>
              Start Hiring in Four Simple Steps
            </h2>

            <p>
              Create your employer account, publish a job and start
              receiving candidate applications.
            </p>
          </div>

          <div className="nujobs-employer-steps">

            <div className="nujobs-employer-step">
              <div className="step-number">
                1
              </div>

              <h3>
                Create Account
              </h3>

              <p>
                Sign up as an employer on NuJobs.
              </p>
            </div>

            <div className="step-arrow">
              <ArrowRightOutlined />
            </div>

            <div className="nujobs-employer-step">
              <div className="step-number">
                2
              </div>

              <h3>
                Post Your Job
              </h3>

              <p>
                Add job details, required skills and hiring requirements.
              </p>
            </div>

            <div className="step-arrow">
              <ArrowRightOutlined />
            </div>

            <div className="nujobs-employer-step">
              <div className="step-number">
                3
              </div>

              <h3>
                Candidates Apply
              </h3>

              <p>
                Candidates discover your job and apply directly.
              </p>
            </div>

            <div className="step-arrow">
              <ArrowRightOutlined />
            </div>

            <div className="nujobs-employer-step">
              <div className="step-number">
                4
              </div>

              <h3>
                Review Applications
              </h3>

              <p>
                Access candidate applications from your employer dashboard.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* ======================================================
          PRICING
      ====================================================== */}

      <section
        className="nujobs-employer-pricing-section"
        id="pricing"
      >
        <div className="nujobs-employer-container">

          <div className="nujobs-employer-section-heading">
            <span>
              SIMPLE PRICING
            </span>

            <h2>
              Choose How Many Jobs You Want to Post
            </h2>

            <p>
              Buy job credits based on your hiring needs.
              No complicated recruitment packages.
            </p>
          </div>

          <div className="nujobs-employer-pricing-grid">

            {pricingPlans.map((plan, index) => (
              <div
                key={index}
                className={`nujobs-employer-price-card ${
                  plan.popular ? "popular" : ""
                }`}
              >

                {plan.popular && (
                  <div className="popular-label">
                    MOST POPULAR
                  </div>
                )}

                <h3>
                  {plan.name}
                </h3>

                <div className="job-credit-count">
                  {plan.jobs}
                </div>

                <span className="job-credit-label">
                  Job {plan.jobs > 1 ? "Credits" : "Credit"}
                </span>

                <div className="price-value">
                  {plan.price}
                </div>

                <p className="price-per-job">
                  {plan.perJob}
                </p>

                <div className="pricing-features">

                  <div>
                    <CheckCircleOutlined />
                    Post Jobs on NuJobs
                  </div>

                  <div>
                    <CheckCircleOutlined />
                    Receive Candidate Applications
                  </div>

                  <div>
                    <CheckCircleOutlined />
                    Employer Dashboard
                  </div>

                  <div>
                    <CheckCircleOutlined />
                    View Applicant Details
                  </div>

                </div>

                <Link
                  to="/signup/nujobs"
                  className={
                    plan.popular
                      ? "pricing-primary-btn"
                      : "pricing-secondary-btn"
                  }
                >
                  {plan.buttonText}
                </Link>

              </div>
            ))}

          </div>

        </div>
      </section>

      {/* ======================================================
          QHRFLOW UPSELL
      ====================================================== */}

      <section className="nujobs-employer-qhrflow">
        <div className="nujobs-employer-container">

          <div className="nujobs-qhrflow-card">

            <div>
              <span className="qhrflow-label">
                NEED MORE RECRUITMENT TOOLS?
              </span>

              <h2>
                Move Beyond Job Posting with QHRFlow
              </h2>

              <p>
                NuJobs is designed for simple job posting and receiving
                applications. For resume sourcing, candidate matching,
                recruitment workflow, team collaboration and applicant
                tracking, use QHRFlow.
              </p>
            </div>

            <Link
              to="/home"
              className="qhrflow-button"
            >
              Explore QHRFlow
              <ArrowRightOutlined />
            </Link>

          </div>

        </div>
      </section>

      {/* ======================================================
          FINAL CTA
      ====================================================== */}

      <section className="nujobs-employer-final-cta">
        <div className="nujobs-employer-container">

          <h2>
            Ready to Find Your Next Hire?
          </h2>

          <p>
            Post your opportunity on NuJobs and start receiving
            candidate applications.
          </p>

          <Link
            to="/signup/nujobs"
            className="final-cta-button"
          >
            Post a Job — Starting at ₹299
            <ArrowRightOutlined />
          </Link>

        </div>
      </section>
    <FooterNuJobs/>
    </div>
  );
}